





































import { Vue, Component, Watch } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import { palyoffBaseInfo } from './api/index';
import { getLocalTime } from '../../views/2019VoteForTopTenChongqingMerchants/util/index';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { Toast } from 'vant';

@Component({
  components: {
    Banner,
  },
})
export default class Home extends Vue {
  bannerSrc = require('./assets/banner.jpg');
  isHome: boolean = true;

  created() {
    palyoffBaseInfo().then((res: any) => {
      console.log(getLocalTime(res.data.startTime));
    });
    appShare({
      title: '第八届中国创新创业大赛',
      url: window.location.href,
      subtitle: '“重庆·大足锻打刀具创意设计专业赛”',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '第八届中国创新创业大赛',
      subtitle: '“重庆·大足锻打刀具创意设计专业赛”',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }

  jumpPage(name: string) {
    // if (name === 'networkVote') {
    //   const time = '2019/10/15';
    //   const d1 = new Date(time.replace(/\-/g, '/'));
    //   const d2 = new Date();
    //   if (d2 <= d1) {
    //     return Toast.fail('未到开放时间');
    //   }
    // }
    this.$router.push({
      name,
    });
  }

  @Watch('$route', {
    immediate: true,
  })
  onRouterChange(to: any, from: any) {
    if (to.name !== 'TheEighthChinaInnovationCompetition') {
      this.isHome = false;
    } else {
      this.isHome = true;
    }
  }
}
